"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourMetrics = void 0;
var BehaviourStatesPerDay_1 = require("./BehaviourStatesPerDay");
var BehaviourMetrics = /** @class */ (function (_super) {
    __extends(BehaviourMetrics, _super);
    function BehaviourMetrics() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "BehaviourMetrics";
        _this.identityId = function () {
            _this.push(function (_) { return "identityId"; });
        };
        _this.behaviourId = function () {
            _this.push(function (_) { return "behaviourId"; });
        };
        _this.statesPerDay = function (config) { return _this.push(function (registry) {
            var entity = new BehaviourStatesPerDay_1.BehaviourStatesPerDay();
            config(entity);
            return "statesPerDay { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return BehaviourMetrics;
}(Array));
exports.BehaviourMetrics = BehaviourMetrics;
//# sourceMappingURL=BehaviourMetrics.js.map